import { createFeatureSelector, createSelector } from '@ngrx/store';

import { selectUserState } from '@store/selectors/user/user.selectors';

import * as fromDocusign from '../../reducers/docusign/docusign.reducer';
import * as fromUser from '../../reducers/user/user.reducer';


export const selectDocusignState = createFeatureSelector<fromDocusign.State>(
  fromDocusign.docusignFeatureKey
);


export const selectSendingEnvelope = createSelector(
    selectDocusignState,
    (state: fromDocusign.State) => state.sendingEnvelope
);
